module.exports = __webpack_public_path__ + "media/images/account/icon2-beab76865e0f5ecd0f1ad86a026bdfe0.svg";